// extracted by mini-css-extract-plugin
module.exports = {"CopyIcon":"member-operations__CopyButton__CopyIcon","CopyButton__button":"member-operations__CopyButton__CopyButton__button"};